"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStarkJs = exports.getStarkCss = void 0;
const getStarkCss = (env) => {
    if (env === 'prd') {
        return "https://client-stark-prd.chewy.com/static/css/main.css";
    }
    return `https://client-stark-${env ? env : 'prd'}.chewy.net/static/css/main.css`;
};
exports.getStarkCss = getStarkCss;
const getStarkJs = (env) => {
    if (env === 'prd') {
        return "https://client-stark-prd.chewy.com/static/js/main.js";
    }
    return `https://client-stark-${env ? env : 'prd'}.chewy.net/static/js/main.js`;
};
exports.getStarkJs = getStarkJs;
//# sourceMappingURL=stark.util.js.map